import { render, staticRenderFns } from "./QuestionTarget.vue?vue&type=template&id=dcc4d7a6&scoped=true&"
import script from "./QuestionTarget.vue?vue&type=script&lang=js&"
export * from "./QuestionTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc4d7a6",
  null
  
)

export default component.exports